import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';
import { darken } from 'polished';

import Logo from './Logo';
import HeaderCartController from '../controllers/HeaderCart.controller';

const StyledDesktopNavigation = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: ${p => p.theme.globalWidthLarge};
  margin: 0 auto;
  padding: 0 ${p => p.theme.gutter};
`;

const NavElement = styled(Link)`
  color: ${p => p.theme.colors.headerFont};
  font-size: 1.125rem;
  font-weight: 700;
  text-decoration: none;
  padding: 0 30px;
  transition: 0.5s color;

  &:hover {
    color: ${p => darken(0.1, p.theme.colors.headerFont)};
  }
`;

const NavSep = styled.span`
  color: ${p => p.theme.colors.headerFont};
  margin: 0;
`;

export default function DesktopNavigation({ left, right }) {
  const renderLeftMenu = left.map(({ id, title, url }) => (
    <NavElement key={id} to={url}>
      {title}
    </NavElement>
  ));

  const renderRightMenu = right.map(({ id, title, url }) => (
    <NavElement key={id} to={url}>
      {title}
    </NavElement>
  ));

  return (
    <StyledDesktopNavigation>
      <Logo width="140px" height="32px" color="#ffffff" />

      <nav>
        {renderLeftMenu}

        <NavSep key="nav-sep"> | </NavSep>

        {renderRightMenu}
      </nav>

      <HeaderCartController />
    </StyledDesktopNavigation>
  );
}

DesktopNavigation.propTypes = {
  left: PropTypes.array,
  right: PropTypes.array
};

DesktopNavigation.defaultProps = {
  left: [],
  right: []
};
